import { render, staticRenderFns } from "./SidebarNewPurchase.vue?vue&type=template&id=0d086d44"
import script from "./SidebarNewPurchase.vue?vue&type=script&lang=js"
export * from "./SidebarNewPurchase.vue?vue&type=script&lang=js"
import style0 from "./SidebarNewPurchase.vue?vue&type=style&index=0&id=0d086d44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports